import React from "react";
import { KeycloakProvider } from "services/keycloak/KeycloakProvider";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import ruRU from "antd/lib/locale/ru_RU";
import { MainLayout } from "components/main-layout/MainLayout";
import { AccountRoutes } from "components/routes/AccountRoutes";
import { CookieNotice } from "components/cookie-notice/CookieNotice";
import { isRu } from "services/region/region";

import en from "./i18n/en.json";
import ru from "./i18n/ru.json";

import "./App.less";

const locale = isRu() ? "ru" : "en";
const messages = isRu() ? ru : en;

if (isRu()) {
  document.documentElement.lang = "ru";
  document.title = "Джеймикс Аккаунт";
}

function App() {
  const content = (
    <IntlProvider
      messages={messages}
      locale={locale}
      defaultLocale="en"
    >
      <CookieNotice />
      <MainLayout>
        <AccountRoutes />
      </MainLayout>
    </IntlProvider>
  );

  return (
    <KeycloakProvider>
      {isRu() ? <ConfigProvider locale={ruRU}>{content}</ConfigProvider> : content}
    </KeycloakProvider>
  );
}

export default App;
